<template>
  <div id="infoTable">      
      <div v-if="data">
        <h1 align="center">Info</h1>
        <a v-bind:href="data.website">
          <img v-bind:src="data.logo_url" >
        </a>
        <br>
        <span>{{data.longName}}</span>
        <br>
        <span>{{data.longBusinessSummary}}</span>
      </div>
  </div>
</template>
<script>
import axios from 'axios';
// import VueApexCharts from 'vue-apexcharts';


export default {
  name: 'InfoComponent',
  props: ['ticker'],
  data() {
    return {
        // ticker: 'AAPL',
        data: null,
    }
  },
  // computed: {},
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      let params = {
        'ticker':this.ticker,
      }
      await axios
        // .get('http://127.0.0.1:5000/api/info', {params:params})
        .get(`${process.env.VUE_APP_DATA_API_HOST}/info`, {params:params})
        .then(response => {
          this.data = response.data['data']
        })
        .catch(e => {
          e
        })
    },
  },
  watch:{
    ticker:function(){
      this.fetchData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>